import { SuccessResult } from "./SuccessResult";

export const PlanPurchaseSuccessResult: React.FC = () => {
  return (
    <SuccessResult
      title="Payment Successful"
      text="Thank you for your payment! Your subscription is now active. Enjoy our premium content."
    />
  );
};
